import { Row, Col, Select, Input, Form, Checkbox, Flex, Button } from 'antd';

import React, { useContext, useState, useEffect } from 'react';
import styled from 'styled-components';

import { DeleteOutlined, UpOutlined, DownOutlined } from '@ant-design/icons';

import { StyledInput } from './common';
import WorkOrderDetailsContext from '../../../containers/WorkOrder/WorkOrderDetailsContext';
import { clearNumber } from './utils';
import { measurementUnits } from '../../../shared/utils';
const { Option } = Select;

const IconCol = styled(Col)`
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
`;

function Parts({ deleteSubItem, changeSubItem, item, woLineItemKey }) {
  const contextValue = useContext(WorkOrderDetailsContext);

  const { shopParts, onAddNewPart } = contextValue;
  const [removing, setRemoving] = useState(false);

  const [filteredOptions, setFilteredOptions] = useState(shopParts);
  const [localCost, setLocalCost] = useState(String(item.cost ?? ''));
  const [localMeas, setLocalMeas] = useState(String(item.volumeunit ?? ''));
  const [localAmount, setLocalAmount] = useState(String(item.amount ?? ''));

  useEffect(() => {
    setLocalCost(String(item.cost ?? ''));
  }, [item.cost]);

  useEffect(() => {
    setLocalAmount(String(item.amount ?? ''));
  }, [item.amount]);

  useEffect(() => {
    setLocalMeas(String(item.volumeunit ?? ''));
  }, [item.volumeunit]);

  useEffect(() => {
    if (shopParts.length) {
      setFilteredOptions(shopParts);
    }
  }, [shopParts]);

  const handleSearch = (value) => {
    const filtered = shopParts.filter((item) => {
      const match = item.name.toLowerCase().includes(value.toLowerCase());
      return match;
    });

    setFilteredOptions(filtered);
  };

  const handleSelect = (value) => {
    const selectedPart = shopParts.find((item) => item.id === Number(value));
    changeSubItem({
      id_vehicle_part: selectedPart.id,
      cost: parseFloat(selectedPart.cost),
      name: selectedPart.name,
      is_external_part: selectedPart.is_external_part || false,
      volumeunit: selectedPart.volumeunit,
    });
  };

  const onRemove = () => {
    setRemoving(true);

    setTimeout(() => {
      deleteSubItem();
    }, 300);
  };

  return (
    <Row style={{ marginTop: '10px' }}>
      <Col span={10}>
        <Select
          style={{ width: '90%' }}
          onChange={() => {}}
          placeholder="Select part"
          showSearch
          showArrow={true}
          value={item.id_vehicle_part ? String(item.id_vehicle_part) : null}
          filterOption={false}
          onSearch={handleSearch}
          onSelect={(value) => {
            if (value === 'add-new') {
              onAddNewPart('', woLineItemKey, item.key);
            } else {
              handleSelect(value);
            }
          }}
          data-testid="select-part-dropdown"
        >
          <Option value="add-new" style={{ color: '#1890ff' }}>
            Add New Part
          </Option>
          {filteredOptions.length > 0 ? (
            filteredOptions.map((item) => {
              return (
                <Option key={item.id} value={String(item.id)}>
                  {item.name}
                </Option>
              );
            })
          ) : (
            <Option disabled>No data</Option>
          )}
        </Select>
        <div style={{ marginTop: '10px' }}>
          <Checkbox
            checked={item.is_external_part}
            onChange={(e) => {
              changeSubItem({ is_external_part: e.target.checked });
            }}
          >
            Mark as External Part
          </Checkbox>
        </div>
      </Col>
      <Col span={2}>
        <StyledInput
          onClick={(e) => e.stopPropagation()}
          value={localAmount}
          onChange={(e) => {
            const cleanedValue = clearNumber(e.target.value);
            setLocalAmount(cleanedValue);
          }}
          onBlur={() => {
            const finalValue = parseFloat(localAmount);
            if (!isNaN(finalValue)) {
              changeSubItem({
                amount: parseFloat(finalValue.toFixed(2)),
              });
            } else {
              changeSubItem({ amount: 0 });
            }
          }}
          data-testid="part-quantity-input"
        />
      </Col>
      <Col span={3} style={{ paddingLeft: '10px' }}>
        <Select
          name="volumeunit"
          style={{ width: '100%' }}
          placeholder="-"
          value={localMeas}
          onChange={(e) => {
            setLocalMeas(e);
            changeSubItem({ volumeunit: e });
          }}
          data-testid="part-meas-unit-dropdown"
        >
          <Select.Option value="">-</Select.Option>
          {measurementUnits.map((unit) => (
            <Select.Option key={unit} value={unit}>
              {unit}
            </Select.Option>
          ))}
        </Select>
      </Col>
      <Col span={2} style={{ paddingLeft: '10px' }}>
        <StyledInput
          prefix="$"
          value={localCost}
          onChange={(e) => {
            const cleanedValue = clearNumber(e.target.value);
            setLocalCost(cleanedValue);
          }}
          onBlur={() => {
            const finalValue = parseFloat(localCost);
            if (!isNaN(finalValue)) {
              changeSubItem({ cost: finalValue });
            }
          }}
          data-testid="part-cost-input"
        />
      </Col>
      <Col span={2} style={{ paddingLeft: '10px' }}>
        <StyledInput
          prefix="%"
          value={String(clearNumber(item.markup))}
          onChange={(e) => {
            const { value } = e.target;
            changeSubItem({
              markup: parseInt(clearNumber(value) || 0),
            });
          }}
          data-testid="part-markup-input"
        />
      </Col>
      <Col span={3} style={{ paddingLeft: '10px' }}>
        <StyledInput
          onClick={(e) => e.stopPropagation()}
          prefix="$"
          readOnly
          value={String(
            (
              (item.cost + (item.cost * item.markup) / 100) *
              item.amount
            ).toFixed(2)
          )}
          data-testid="part-amount-input"
        />
      </Col>
      <IconCol span={2}>
        <Button
          icon={<DeleteOutlined />}
          style={{ fontSize: '20px' }}
          type="text"
          danger
          onClick={onRemove}
          loading={removing}
          data-testid="part-delete-button"
        />

        <Flex vertical>
          <UpOutlined />
          <DownOutlined />
        </Flex>
      </IconCol>
    </Row>
  );
}

export default Parts;
